// Mise en page principale de l'espace authentifié (sidebar + header + contenu).
import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import AbonnementBanniere from "@/components/AbonnementBanniere";

export function AppLayout() {
  return (
    <div className="flex min-h-screen bg-[#E8F4F4]">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 p-6 md:p-8 overflow-y-auto">
          <AbonnementBanniere />
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default AppLayout;
